
import Vue from 'vue'
import LazyLoad from 'vanilla-lazyload'
import { TARGET_SELECTOR, THRESHOLD, LOADED_SELECTOR } from '@/common/constants'
import { transformImageResolutions } from '../utils'

const lazyloadOptions = {
  elements_selector: TARGET_SELECTOR,
  threshold: THRESHOLD,
  class_loaded: LOADED_SELECTOR
}

const runLazyLoad = () => {
  if (!window.lazyLoadInstance)
    window.lazyLoadInstance = new LazyLoad(lazyloadOptions)
  window.lazyLoadInstance.update()
}

export default Vue.extend({
  props: {
    isLazy: {
      type: Boolean,
      required: false,
      default: false
    },
    shouldUseSrcset: {
      type: Boolean,
      required: false,
      default: true
    },
    showPlaceholder: {
      type: Boolean,
      required: false,
      default: false
    },
    showLoader: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    srcset() {
      if (!this.shouldUseSrcset) return undefined
      const src = this.$attrs['data-src']
      if (!src) return undefined
      const resolutions = transformImageResolutions(src)

      return resolutions.srcset
    }
  },
  updated(): void {
    if (this.isLazy) runLazyLoad()
  },
  mounted(): void {
    if (this.isLazy) runLazyLoad()
  }
})
